<template>
    <div class="cont-tit">
        <h2 class="page-title">Business Strategy</h2>
        <p class="page-desc">
            Osang Technology Co., Ltd. will build a global infrastructure using AWS cloud services and successfully enter overseas markets by supporting various languages ​​and strengthening data security.
            By stably entering the initial market through thorough research and strategic marketing tailored to market characteristics,
            We will continue to improve our services based on customer feedback and strengthen our global competitiveness. <br>
            Through this, we will continue to take on constant challenges with the goal of long-term global growth and improved brand awareness.
            As a member of AWS's APN, we aim to become an AWS Network Partner, and as an AWS DSA partner, we are developing CLOUD Platform technology and sales.
            Based on this know-how and technology, we are planning successful overseas expansion of OSE-MCommerce Platform Ver.1.2.
        </p>

        <div class="strategy">
            <h3 class="strategy__tit">Overseas expansion strategic plan</h3>
            <div class="strategy__wrap">
                <div class="strategy__line"></div>
                <ul class="strategy__list">
                    <li class="strategy__item">
                        <h4>1st year</h4>
                        <p>Establishment of foundation and <br> initial market entry</p>
                        <ul>
                            <li>Technology and infrastructure upgrade AWS service integration (EC2, S3, RDS, Elastic Beanstalk, Lambda) Data security and compliance Multi-language support</li>
                            <li>Product launch and initial marketing AWS Marketplace registration Initial customer acquisition (promotions, discounts, free trials) Partnership development (affiliate with local partners)</li>
                        </ul>
                    </li>
                    <li class="strategy__item">
                        <h4>2nd year</h4>
                        <p>Grow and Expand</p>
                        <ul>
                            <li>Market expansion Implement regional marketing strategies Collect customer feedback and improve products</li>
                            <li>Improve customer support and services Build a local support team Provide training and materials (webinars, online courses)</li>
                            <li>Expand partnerships and networks Strengthen strategic alliances</li>
                        </ul>
                    </li>
                    <li class="strategy__item">
                        <h4>3rd year</h4>
                        <p>Sustainable growth and innovation</p>
                        <ul>
                            <li>Establish technological leadership Add innovative features (integrate AI, machine learning) Cloud optimization (utilize AWS' latest technology)</li>
                            <li>Expand market dominance Strengthen brand awareness (utilize success stories, customer reviews) Expand global reach</li>
                            <li>Establish sustainable business model Achieve financial independence Building an ecosystem (participating users, developers, and partners)</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>


</template>

<script>
    export default {

    };
</script>